/* eslint-disable */
require('./close')
require('./door')
require('./info')
require('./menu')
require('./pano_drone')
require('./pano_person')
